var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoInternet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 292.541,
    height: 120.955,
    viewBox: "0 0 292.541 120.955",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0420\\u043E\\u0437\\u0435\\u0442\\u043A\\u0430",
    transform: "translate(435.811 -603.388) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_753",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 753",
    transform: "translate(0 -20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_729",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 729",
    transform: "translate(636.669 163.271)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_997",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 997",
    width: 8.204,
    height: 49.202,
    transform: "translate(25.39 0)",
    fill: "#3b7280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_2168",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 2168",
    d: "M575.475,217.135H516.51V187.663A29.493,29.493,0,0,1,546,158.17h0a29.472,29.472,0,0,1,29.472,29.493Z",
    transform: "translate(-516.51 -114.71)",
    fill: "#5acbc7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_2169",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 2169",
    d: "M15.616,20.175l-5.078-5.006L17.8,5.5,12.2,0,.462,15.653l5.587,5.5L0,32.662Z",
    transform: "translate(695.606 249.561) rotate(-22)",
    fill: "#ffc13e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_2171",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 2171",
    d: "M487.68,178.577l9.308-.351-7.825-17.213,10.248-.382,12.639,27.876-10.237.367,5.4,17.994Z",
    transform: "translate(115.905 82.404)",
    fill: "#ffc13e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_752",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 752",
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_2165",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 2165",
    d: "M530.4,258.781h-9.7V246.7a4.861,4.861,0,0,1,4.84-4.861h0A4.861,4.861,0,0,1,530.4,246.7Z",
    transform: "translate(124.563 52.053)",
    fill: "#3b7280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_2166",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 2166",
    d: "M546.051,258.781h-9.7V246.7a4.861,4.861,0,0,1,4.861-4.861h0a4.861,4.861,0,0,1,4.84,4.861Z",
    transform: "translate(141.01 52.053)",
    fill: "#3b7280"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_995",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 995",
    width: 8.204,
    height: 52.976,
    transform: "translate(662.06 362.835)",
    fill: "#3b7280"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_2167",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 2167",
    d: "M516.51,250.1h58.965v29.493A29.472,29.472,0,0,1,546,309.065h0a29.472,29.472,0,0,1-29.493-29.472Z",
    transform: "translate(120.159 59.369)",
    fill: "#5acbc7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_2170",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 2170",
    d: "M13.7,19.234l-1.041-7.156L1.154,18.892,0,11.008,18.624,0l1.143,7.875L32.021,2.9Z",
    transform: "matrix(0.848, -0.53, 0.53, 0.848, 603.388, 354.839)",
    fill: "#ffc13e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_2173",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 2173",
    d: "M571.7,250.5l-5.822,7.2,9.083,10.456-6.41,7.937L553.87,259.128l6.4-7.913L552.55,238.24Z",
    transform: "translate(149.275 65.956)",
    fill: "#ffc13e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInternet);
export default __webpack_public_path__ + "static/media/no_internet.1ca158ebc422f9ab6aed231e06871ecf.svg";
export { ForwardRef as ReactComponent };